uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

// x: rotation, counter clock wise
// y: distance from center (1==half height)
vec2 toPolarUV(vec2 uv, vec2 resolution) {
    vec2 p =  uv;
    p -= 0.5;
    p.x = p.x * (resolution.x / resolution.y);

    float pixelAngle = atan(p.x, p.y);
    float pixelDistance = length(p) * 2.0;

    return vec2(pixelAngle / 6.28318530717958623199592693708 + 0.5, pixelDistance);
}

// Returns a cell in vec3 formation:
//  xy: -1.0:1.0 position in cell
//  zw: x and y index of cell
vec4 makeCell(vec2 st, float width) {
    st = st + vec2(width / 2.); // This centers the grid
    vec2 p = (mod(st, width) / width) * 2.0 - 1.0;
    return vec4(p, floor(st / width));
}

vec4 makeRings(vec2 polar, vec2 width) {
    vec2 p = mod(polar, width) / width;
    return vec4(p, floor(polar / width));
}

float easeOutCirc(float x) {
    return sqrt(1.0 - pow(x - 1.0, 2.0));
}

void main() {

    vec2 uv = vUv;

    vec2 polar = toPolarUV(uv, resolution);
    float size = 5.0;
    
    float ringCount = 8.0;
    float ringSplitCount = 5.0;

    polar.x += time * 0.00001;
    vec4 ringForwards = makeRings(polar, vec2(1.0/ringSplitCount, 1.0/ringCount));
    polar.x -= time * 0.00002;
    vec4 ringBackwards = makeRings(polar, vec2(1.0/ringSplitCount, 1.0/ringCount));

    vec4 ring = mix(ringForwards, ringBackwards, step(0.5, mod(ringForwards.y * 2.0, 1.0)));

    float v = 0.0;

    float shadow = clamp(easeOutCirc(ring.y) * 2.0, 0.0, 1.0);
    shadow = shadow * 0.3 + 0.7;

    //float x =  mod(ring.x + ring.z * 0.1, 1.0);
    vec2 ringIndex = ring.zw;
    v = mod(ringIndex.x + ringIndex.y, ringSplitCount) / (ringSplitCount - 1.0);
    // v = (v * 0.8 + 0.2;
    v *= shadow;

    gl_FragColor = vec4(vec3(v), 1.0);


}